import React from 'react';
import { Tag } from 'antd';

/**
 * Single source of truth for Light App service status -> color mapping.
 *
 * Previously this map was duplicated across the admin Services page and the
 * user-side MyServices / ServiceDetail pages and had drifted (only the admin
 * copy handled the `suspended` state). Import this helper instead of writing a
 * local copy so all surfaces stay in sync.
 */
export const SERVICE_STATUS_COLORS = {
  running: 'success',
  stopped: 'default',
  pending: 'processing',
  error: 'error',
  failed: 'error',
  starting: 'processing',
  stopping: 'warning',
  suspended: 'error',
};

/**
 * Resolve an antd color token for a given service status.
 * @param {string} status
 * @returns {string}
 */
export function serviceStatusColor(status) {
  return SERVICE_STATUS_COLORS[status?.toLowerCase()] || 'default';
}

/**
 * Reusable status Tag for a Light App service.
 */
const ServiceStatusTag = ({ status }) => (
  <Tag color={serviceStatusColor(status)}>{status?.toUpperCase() || 'UNKNOWN'}</Tag>
);

export default ServiceStatusTag;
